<script setup lang="ts">
import { useI18n } from 'vue-i18n'

defineProps<{
  variant: 'no-galleries' | 'storage-full'
  /** Formatted storage quota for the explanation note. */
  quota?: string
}>()

const emit = defineEmits<{
  create: []
  'add-link': []
}>()

const { t } = useI18n()
</script>

<template>
  <div
    class="rounded-2xl border border-dashed border-slate-700 bg-slate-800/40 px-6 py-14 text-center"
    :data-variant="variant"
    data-testid="gallery-empty-state"
  >
    <div class="mx-auto mb-4 w-14 h-14 rounded-2xl bg-slate-700/60 flex items-center justify-center text-slate-400">
      <svg class="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M2.25 15.75l5.159-5.159a2.25 2.25 0 013.182 0l5.159 5.159m-1.5-1.5l1.409-1.409a2.25 2.25 0 013.182 0l2.909 2.909M3.75 21h16.5A2.25 2.25 0 0022.5 18.75V5.25A2.25 2.25 0 0020.25 3H3.75A2.25 2.25 0 001.5 5.25v13.5A2.25 2.25 0 003.75 21zm10.5-11.25h.008v.008h-.008V9.75z" />
      </svg>
    </div>

    <template v-if="variant === 'no-galleries'">
      <h2 class="text-lg font-semibold text-white">{{ t('galleries.empty.title') }}</h2>
      <p class="mx-auto mt-2 max-w-md text-sm text-slate-400">{{ t('galleries.empty.body') }}</p>
      <button
        type="button"
        class="mt-6 inline-flex items-center gap-2 bg-emerald-500 hover:bg-emerald-400 text-white font-semibold rounded-lg px-5 py-2.5 text-sm transition-colors"
        @click="emit('create')"
      >
        {{ t('galleries.create') }}
      </button>
      <p v-if="quota" class="mt-4 text-xs text-slate-500">{{ t('galleries.empty.quota_note', { quota }) }}</p>
    </template>

    <template v-else>
      <h2 class="text-lg font-semibold text-white">{{ t('galleries.empty.full_title') }}</h2>
      <p class="mx-auto mt-2 max-w-md text-sm text-slate-400">{{ t('galleries.empty.full_body') }}</p>
      <button
        type="button"
        class="mt-6 inline-flex items-center gap-2 bg-emerald-500 hover:bg-emerald-400 text-white font-semibold rounded-lg px-5 py-2.5 text-sm transition-colors"
        @click="emit('add-link')"
      >
        {{ t('galleries.dropzone.add_link') }}
      </button>
    </template>
  </div>
</template>
